<template>
  <div>
    <div class="nav_link">
        <el-link type="primary"><router-link to="/books_xr">候选资源清单</router-link></el-link>
        <el-link type="primary"><router-link to="/">教辅资源编辑</router-link></el-link>
    </div>
    <div class="nav_bar">
       <div class="title">当前资源关联情况</div>
         <div class="btn">
            <el-button @click="dialogFormVisible = true">创建关联</el-button>
        </div>
    </div>
  <el-table
        ref="singleTable"
        :data="booksData"
        highlight-current-row
        @current-change="handleCurrentChange"
        style="width: 100%">
    <el-table-column
        type="index"
        width="50">
    </el-table-column>
    <el-table-column
        property="anBookId"
        label="教辅id-aw"
        width="120">
    </el-table-column>
    <el-table-column
        property="anBookName"
        label="教辅名称aw"
        width="180">
    </el-table-column>
    <el-table-column
        property="xrBookId"
        label="教辅id-xr"
        width="120">
    </el-table-column>
    <el-table-column
        property="xrBookName"
        label="教辅名称xr"
        width="180">
    </el-table-column>
    <el-table-column label="操作">
            <template slot-scope="scope">
                <el-button
                    size="mini"
                    type="danger"
                    @click="unrelate_action(scope.row)">删除</el-button>
            </template>
    </el-table-column>   
  </el-table>

    <el-dialog title="创建匹配关系" :visible.sync="dialogFormVisible">
        <el-form :model="form">
              <el-form-item label="暗物书id" :label-width="formLabelWidth">
                <el-input v-model="form.anBookId" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="暗物书名" :label-width="formLabelWidth">
                <el-input v-model="form.anBookName" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="小睿书id" :label-width="formLabelWidth">
                <el-input v-model="form.xrBookId" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="小睿书名" :label-width="formLabelWidth">
                <el-input v-model="form.xrBookName" autocomplete="off"></el-input>
              </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
              <el-button @click="dialogFormVisible = false">取 消</el-button>
              <el-button type="primary" @click="click_new_relation">确 定</el-button>
        </div>
    </el-dialog>

  </div>
</template>

<script>

  import {load_books,new_relate_book,un_relate_book} from '@/api/edas';
  import { MessageBox, Message } from 'element-ui';


  export default {
    data() {
      return {
        booksData: [],
        currentRow: null,
        form : {
          anBookId:'',
          anBookName : '',
          xrBookId : '',
          xrBookName : ''
        },
        formLabelWidth: '80px',
        dialogTableVisible: false,
        dialogFormVisible: false,
      }
    },

    mounted:function(){
        this.load_datas();
    },

    methods: {

      load_datas : function(){
        load_books().then(resp=>{
            console.log(resp);
            this.booksData = resp.data;
        });
      },

      unrelate_action:function(item){
         //删除关系
        this.$confirm('此操作将永久删除该关系, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          un_relate_book(item.anBookId).then(resp =>{
              Message({
                    message: '操作成功' || resp.resultMsg,
                    type: 'tip',
                    duration: 5 * 1000
              });
              this.load_datas();
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });



      },

      setCurrent(row) {
        this.$refs.singleTable.setCurrentRow(row);
      },
      handleCurrentChange(val) {
        this.currentRow = val;
      },

      click_new_relation:function(){
         new_relate_book(this.form.anBookId,this.form.anBookName,this.form.xrBookId,this.form.xrBookName).then(resp=>{
            console.log(resp);
            if(resp.code == '001'){
                    Message({
                        message: '操作成功' || res.resultMsg,
                        type: 'tip',
                        duration: 5 * 1000
                    });
                    this.load_datas();
                    this.dialogFormVisible = false;
            }else{
                Message({
                        message: '操作失败' ,
                        type: 'error',
                        duration: 5 * 1000
                });
            }
         });
      }
    }
  }
</script>


<style lang="less">
    .nav_link{
        margin-right : 20px;
        font-size: 20px;
        margin: 10px;
    }
    .nav_bar{
        font-size: 18px;
        margin: 10px;
        .title{
            margin-left: auto;
        }
        .btn{
            font-size: 1px;
        }
    }

</style>


// WEBPACK FOOTER //
// src/components/relate_books/list.vue